export default {
    stage: "info",
    info: {},
    share: {},
    verify: {
        post_id: null,
        url: "",
        button: false
    }
}